import { motion } from 'framer-motion';

const testimonials = [
  {
    quote: 'As I was reading the book, I felt seen. Especially the part where it said "I\'ll get serious next month"',
    name: 'Shay C.',
    role: 'Professional Pet Stylist',
  },
  {
    quote: 'This book isn\'t here to tell you "you don\'t budget" you already know that. This book is here to help you understand why you don\'t budget and to help you understand your relationship with money.\n' +
        'If you want to fix a problem you have to understand why the problem exists in the first place and this book guides you through that process eloquently and intelligently.',
    name: 'Uriah S.',
    role: 'Design Specialist',
  },
  {
    quote: 'I started my emergency fund within a week of reading this. The step-by-step approach made it feel doable.',
    name: 'Tammy M.',
    role: 'Optometric Technician',
  },
];

export function Testimonials() {
  return (
    <section className="py-20 sm:py-28 bg-sage/5">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.5 }}
        >
          <h2 className="font-serif text-3xl sm:text-4xl font-bold text-text">
            What readers are saying
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((t, i) => (
            <motion.blockquote
              key={t.name}
              className="bg-white p-8 rounded-xl shadow-sm border border-sage/10"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-50px' }}
              transition={{ duration: 0.5, delay: i * 0.15 }}
            >
              <div className="text-sage text-4xl font-serif leading-none mb-4">&ldquo;</div>
              <p className="text-text leading-relaxed mb-6 italic font-serif">
                {t.quote}
              </p>
              <footer>
                <p className="font-semibold text-text">{t.name}</p>
                <p className="text-sm text-text-light">{t.role}</p>
              </footer>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}
